import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ForceDecisionPopup', {
    forceApproveButtonText: 'Force approval',
    forceRejectButtonText: 'Force rejection',
    descriptionText:
        'Please provide a comment (optional) to let the Approvers and the Requester know why you decided to do so.',
    popupTitle: 'Force the decision',
    forceRejectButtonTitle: 'Force rejection of this request as the company administrator',
    forceApproveButtonTitle: 'Force approval of this request as the company administrator',
});
